import shared from "@/components/research/shared.js";

// Global state for cross-chart vertical line coordination
const crossChartState = {
    activeX: null,
    activeChartId: null,
    chartInstances: new Map(),
    redrawPending: new Set()
};

//sharePlugin requires the chart to have an id.
const verticalLine = {
    id: "vertical-line",
    beforeInit: (chart) => {
        // Register this chart instance
        const chartId = chart.canvas?.id || chart;
        crossChartState.chartInstances.set(chartId, chart);
        crossChartState.redrawPending.add(chartId);
    },
    beforeDestroy: (chart) => {
        // Clean up
        const chartId = chart.canvas?.id || chart;
        crossChartState.chartInstances.delete(chartId);
        crossChartState.redrawPending.delete(chartId);

        if (crossChartState.activeChartId === chartId) {
            crossChartState.activeX = null;
            crossChartState.activeChartId = null;
        }
    },
    afterDraw: chart => {
        const chartId = chart.canvas?.id || chart;
        const hasLocalActive = chart.tooltip?._active?.length;
        const hasGlobalActive = crossChartState.activeX !== null;

        // Update global state if this chart has active tooltip
        if (hasLocalActive) {
            const x = chart.tooltip._active[0].element.x;
            const stateChanged = crossChartState.activeX !== x || crossChartState.activeChartId !== chartId;

            if (stateChanged) {
                crossChartState.activeX = x;
                crossChartState.activeChartId = chartId;

                // Mark all other charts for redraw to show the line
                crossChartState.chartInstances.forEach((otherChart, otherId) => {
                    if (otherId !== chartId) {
                        crossChartState.redrawPending.add(otherId);
                        // Trigger immediate redraw for cross-chart coordination
                        setTimeout(() => {
                            if (crossChartState.chartInstances.has(otherId)) {
                                otherChart.update('none');
                            }
                        }, 0);
                    }
                });
            }
        }

        // Always draw line if there's any active position (local or global)
        if (crossChartState.activeX !== null) {
            // Find the appropriate y-axis scale
            let yAxis = chart.scales.y_right || chart.scales.y_left;
            if (!yAxis) return;

            let ctx = chart.ctx;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(crossChartState.activeX, yAxis.top);
            ctx.lineTo(crossChartState.activeX, yAxis.bottom);
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'rgba(0, 0, 255, 0.4)';
            ctx.stroke();
            ctx.restore();
        }

        // Clear the redraw pending flag for this chart
        crossChartState.redrawPending.delete(chartId);
    },
    afterEvent: (chart, args) => {
        const chartId = chart.canvas?.id || chart;

        if (args.event.type === 'mouseout') {
            // Check if this chart was the active one
            if (crossChartState.activeChartId === chartId) {
                // Check if any other chart still has active tooltips
                let otherChartActive = false;
                let newActiveX = null;
                let newActiveChartId = null;

                crossChartState.chartInstances.forEach((otherChart, otherId) => {
                    if (otherId !== chartId && otherChart.tooltip?._active?.length) {
                        otherChartActive = true;
                        newActiveX = otherChart.tooltip._active[0].element.x;
                        newActiveChartId = otherId;
                    }
                });

                if (otherChartActive) {
                    // Another chart is active, update the state
                    crossChartState.activeX = newActiveX;
                    crossChartState.activeChartId = newActiveChartId;
                } else {
                    // No charts are active, clear everything
                    crossChartState.activeX = null;
                    crossChartState.activeChartId = null;
                }

                // Redraw all charts to reflect the state change
                crossChartState.chartInstances.forEach(chartInstance => {
                    chartInstance.update('none');
                });
            }
        }
    }
}
export {
    verticalLine
}
